
import React from 'react'
import { useHistory } from 'react-router-dom'
import { renderPost } from '../../Post/MasoryPostCard/utils'
import styles from './FranchiseeCampaing.module.css'
const FranchiseeCampaing = ({ campaings }) => {
    const history = useHistory()
    return (

        <div className={styles.grid_list}>
            {
                campaings.map(campaing => (

                    <div className='pointer' onClick={(e)=>{
                        history.push("/Post/"+campaing.postId._id)
                    }}>
                        {renderPost(campaing.postId)}
                    </div>
                ))
            }
        </div>

    )
}

export default FranchiseeCampaing